var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider tw-flex tw-items-center tw-my-[56px]"},[_c('div',{staticClass:"line tw-h-[2px] tw-w-full tw-bg-[#D7E3E3]"}),_c('p',{staticClass:"tw-mx-small+"},[_vm._v(" ALI ")]),_c('div',{staticClass:"line tw-h-[2px] tw-w-full tw-bg-[#D7E3E3]"})])
}]

export { render, staticRenderFns }